import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import StudentProfileComponent from './components/StudentProfileComponent';

const StudentProfile = () => {
  return renderComponent(<StudentProfileComponent />);
};

export default StudentProfile;
